//import React from "react";
import { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { clearAuthentication } from "@lib/authentication/SessionStore";
import App from "./App";
import "@common/i18n";
import "./index.scss";
import { OidcSessionBridge } from "@common/auth/OidcSessionBridge";
import { buildOidcSettings, getPersistedAuthority, getUserManager, initUserManager } from "@common/auth/userManager";

/**
 * Multi-tenant bootstrap: l'authority OIDC (realm del macro-cliente) è scoperta
 * a runtime e persistita. In entrambi i casi si monta l'app completa (Router +
 * AppLayout), così la LoginPage vive sempre nella stessa shell (logo, footer):
 * - Authority ASSENTE → app SENZA AuthProvider (nessun realm noto). La LoginPage
 *   mostra l'identifier-first discovery.
 * - Authority PRESENTE (post-discovery / reload / callback) → monta anche
 *   l'{@link AuthProvider} OIDC con quel realm.
 */
function AuthBootstrap(): ReactElement {
  const authority = getPersistedAuthority();
  if (!authority) {
    return <App />;
  }
  const userManager = getUserManager() ?? initUserManager(authority);
  return (
    <AuthProvider
      userManager={userManager}
      {...buildOidcSettings(authority)}
      onSigninCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      <OidcSessionBridge>
        <App />
      </OidcSessionBridge>
    </AuthProvider>
  );
}

// Nessun realm noto → nessun OidcSessionBridge che idrati la sessione: inizializzala
// (non autenticata) così gli AuthGuard reindirizzano a /login invece di restare
// sospesi (initialized=false).
if (!getPersistedAuthority()) {
  clearAuthentication();
}

createRoot(document.getElementById("root")!).render(<AuthBootstrap />);
